export const DEMO_CAMPAIGN_ID = 'demo-campaign';

export const DEMO_CAMPAIGN_CHARACTERS = Object.freeze([
  Object.freeze({
    charId: 'demo-lika',
    id: 'demo-lika',
    name: "Li'ka",
    subtitle: 'Half-Elf Cleric',
    race: 'Half-Elf',
    charClass: 'Cleric',
    cls: 'Cleric',
    level: 5,
    hp: 24,
    maxHp: 42,
    mp: 0,
    maxMp: 0,
  }),
  Object.freeze({
    charId: 'demo-ventyl',
    id: 'demo-ventyl',
    name: 'Ventyl',
    subtitle: 'Half-Elf Ranger',
    race: 'Half-Elf',
    charClass: 'Ranger',
    cls: 'Ranger',
    level: 4,
    hp: 31,
    maxHp: 38,
    mp: 0,
    maxMp: 0,
  }),
  Object.freeze({
    charId: 'demo-eve',
    id: 'demo-eve',
    name: 'Eve',
    subtitle: 'Human Ranger',
    race: 'Human',
    charClass: 'Ranger',
    cls: 'Ranger',
    level: 4,
    hp: 29,
    maxHp: 36,
    mp: 0,
    maxMp: 0,
  }),
  Object.freeze({
    charId: 'demo-khan',
    id: 'demo-khan',
    name: 'Khan',
    subtitle: 'Tiefling Rogue',
    race: 'Tiefling',
    charClass: 'Rogue',
    cls: 'Rogue',
    level: 4,
    hp: 27,
    maxHp: 34,
    mp: 0,
    maxMp: 0,
  }),
]);

export const DEFAULT_DEMO_PLAYER_CHAR_ID = DEMO_CAMPAIGN_CHARACTERS[0].charId;

const DEMO_CAMPAIGN_CHARACTER_IDS = new Set(
  DEMO_CAMPAIGN_CHARACTERS.map((character) => character.charId),
);

export const isDemoCampaignCharacterId = (charId) => (
  DEMO_CAMPAIGN_CHARACTER_IDS.has(String(charId || ''))
);

export const getDemoCampaignCharacter = (charId) => (
  DEMO_CAMPAIGN_CHARACTERS.find((character) => character.charId === charId) || null
);

export const buildDemoCampaignSet = () => {
  const characterNames = DEMO_CAMPAIGN_CHARACTERS.map((character) => character.name);
  const campaign = {
    id: DEMO_CAMPAIGN_ID,
    campaignId: DEMO_CAMPAIGN_ID,
    name: 'Demo Campaign',
    role: 'dm',
    isDemo: true,
    dm: 'Demo DM',
    players: DEMO_CAMPAIGN_CHARACTERS.length,
    schedule: 'Demo table',
    blurb: 'A local sample campaign with four pre-built characters.',
    description: 'Explore the DM dashboard or enter as one of the demo characters. This campaign never writes to Convex.',
    party: characterNames,
    yourChar: null,
    icon: '*',
    rune: 'astral',
    paletteIndex: 2,
    hueShift: -18,
    enabledFeatures: null,
  };

  const characters = DEMO_CAMPAIGN_CHARACTERS.map((character, index) => ({
    id: character.charId,
    charId: character.charId,
    name: character.name,
    race: character.race,
    cls: character.cls,
    charClass: character.charClass,
    level: character.level,
    hp: character.hp,
    maxHp: character.maxHp,
    mp: character.mp,
    maxMp: character.maxMp,
    avatar: '',
    note: 'Demo',
    ownerUserId: null,
    isMine: true,
    isPlayable: true,
    isDemo: true,
    campaignId: DEMO_CAMPAIGN_ID,
    paletteIndex: index,
  }));

  const friends = DEMO_CAMPAIGN_CHARACTERS.map((character) => ({
    id: character.charId,
    name: character.name,
    role: 'Demo character',
    status: 'online',
  }));

  return {
    campaign,
    characters,
    friends,
    extra: {
      day: 1,
      sessionCount: 1,
      invite: '',
      quest: 'Learn the table tools',
    },
  };
};

export const mergeDemoCampaignSet = (data, demoCampaignSet = buildDemoCampaignSet()) => {
  const base = data || {};
  const existingCampaigns = base.campaigns || [];
  const campaigns = existingCampaigns.some((campaign) => campaign.id === DEMO_CAMPAIGN_ID)
    ? existingCampaigns.map((campaign) => (
        campaign.id === DEMO_CAMPAIGN_ID ? demoCampaignSet.campaign : campaign
      ))
    : [...existingCampaigns, demoCampaignSet.campaign];

  return {
    ...base,
    campaigns,
    campaignCharacters: {
      ...(base.campaignCharacters || {}),
      [DEMO_CAMPAIGN_ID]: demoCampaignSet.characters,
    },
    campaignFriends: {
      ...(base.campaignFriends || {}),
      [DEMO_CAMPAIGN_ID]: demoCampaignSet.friends,
    },
    campaignExtra: {
      ...(base.campaignExtra || {}),
      [DEMO_CAMPAIGN_ID]: demoCampaignSet.extra,
    },
    announcementsForCampaign: {
      ...(base.announcementsForCampaign || {}),
      [DEMO_CAMPAIGN_ID]: [],
    },
    campaignLoreByCampaign: {
      ...(base.campaignLoreByCampaign || {}),
      [DEMO_CAMPAIGN_ID]: { worldId: null, noWorld: true, entities: [] },
    },
  };
};

export const normalizeDemoCampaignLaunch = ({ role, charId } = {}) => {
  const wantsPlayer = role === 'player' || !!charId;
  if (!wantsPlayer) {
    return { valid: true, role: 'dm', charId: null };
  }

  const resolvedCharId = charId || DEFAULT_DEMO_PLAYER_CHAR_ID;
  if (!isDemoCampaignCharacterId(resolvedCharId)) {
    return {
      valid: false,
      role: 'player',
      charId: resolvedCharId,
      reason: 'unknown-demo-character',
    };
  }

  return { valid: true, role: 'player', charId: resolvedCharId };
};
